import {
    Container,
    Grid,
    Box,
    Typography,
    Card,
    CardContent,
    CardMedia,
    CircularProgress,
    Fade,
    IconButton,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import { useEffect, useState } from 'react';
import HeaderSession from '../utils/headerSession';
import Date from '../utils/date';
import api from '../services/api';
import ButtonLeft from '../utils/buttonLeft';

export default function TitularesInstituicao() {

    const [titulares, setTitulares] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedTitular, setSelectedTitular] = useState(null);

    useEffect(() => {
        buscarTitulares();
    }, []);

    const buscarTitulares = async () => {
        try {
            setLoading(true);

            const response = await api.get('/admins?status=Activo&titular=Sim');

            setTitulares(response?.data?.Admins || []);

        } catch (error) {
            console.error('Erro ao buscar titulares:', error);
        } finally {
            setLoading(false);
        }
    };

    const abrirDetalhes = (titular) => {
        setSelectedTitular(titular);

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const fecharDetalhes = () => {
        setSelectedTitular(null);
    };

    const TitularesDiretores = ({ funcao, label }) => {

        const lista = titulares.filter(
            (titular) => titular.funcao === funcao
        );

        if (lista.length === 0) return null;

        return (
            <Box mb={8}>

                <Typography
                    variant="h5"
                    fontWeight="bold"
                    textAlign="center"
                    sx={{
                        background: '#85287E',
                        color: '#fff',
                        padding: 2,
                        borderRadius: 2,
                        mb: 4,
                        letterSpacing: 1,
                    }}
                >
                    {label}
                </Typography>

                <Grid container spacing={4} justifyContent="center">

                    {lista.map((titular) => (
                        <Grid
                            key={titular._id}
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={4}
                        >
                            <Card
                                onClick={() => abrirDetalhes(titular)}
                                sx={{
                                    borderRadius: 1,
                                    overflow: 'hidden',
                                    cursor: 'pointer',
                                    transition: '.4s',
                                    boxShadow: 3,

                                    '&:hover': {
                                        transform: 'translateY(-8px)',
                                        boxShadow: 8,
                                    },

                                    '&:hover .imagem-card': {
                                        transform: 'scale(1.08)',
                                    }
                                }}
                            >

                                <Box
                                    sx={{
                                        overflow: 'hidden',
                                        height: 380,
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        image={titular?.dadosPessoais?.fotoURL}
                                        alt={titular?.dadosPessoais?.nome}
                                        className="imagem-card"
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            transition: '.5s',
                                        }}
                                    />
                                </Box>

                                <CardContent>

                                    <Typography
                                        variant="subtitle2"
                                        textAlign="center"
                                        color="primary"
                                        fontWeight="bold"
                                        gutterBottom
                                    >
                                        {titular?.funcao}
                                    </Typography>

                                    <Typography
                                        variant="h6"
                                        textAlign="center"
                                        fontWeight="bold"
                                        gutterBottom
                                    >
                                        {titular?.dadosPessoais?.nome}
                                    </Typography>

                                    {selectedTitular?.dataNomeacao &&
                                        <Typography
                                            variant="body2"
                                            textAlign="center"
                                            color="text.secondary"
                                        >
                                            Data de Nomeação:{' '}
                                            <Date date={selectedTitular?.dataNomeacao} />
                                        </Typography>
                                    }

                                </CardContent>

                            </Card>

                        </Grid>
                    ))}

                </Grid>

            </Box>
        );
    };

    return (
        <Container sx={{ minHeight: '100vh', py: 4 }}>

            <HeaderSession title="TITULARES DA ENTIDADE" />

            {loading ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="50vh"
                >
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    {/* DETALHES */}
                    <Fade in={!!selectedTitular} timeout={400}>

                        <Box>
                            {selectedTitular && (
                                <Box
                                    sx={{
                                        mb: 6,
                                        // background: '#fff',
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        boxShadow: 6,
                                        display: 'flex',
                                        flexDirection: {
                                            xs: 'column',
                                            md: 'row',
                                        }
                                    }}
                                >

                                    <Box position="relative" >
                                        <Box>
                                            <Box
                                                sx={{
                                                    overflow: 'hidden',
                                                    height: 380,
                                                    minWidth: 300,
                                                }}
                                            >
                                                <CardMedia
                                                    component="img"
                                                    image={selectedTitular?.dadosPessoais?.fotoURL}
                                                    alt={selectedTitular?.dadosPessoais?.nome}
                                                    className="imagem-card"
                                                    sx={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        transition: '.5s',
                                                    }}
                                                />
                                            </Box>

                                            <CardContent>

                                                <Typography
                                                    variant="subtitle2"
                                                    textAlign="center"
                                                    color="primary"
                                                    fontWeight="bold"
                                                    gutterBottom
                                                >
                                                    {selectedTitular?.funcao}
                                                </Typography>

                                                <Typography
                                                    variant="h6"
                                                    textAlign="center"
                                                    fontWeight="bold"
                                                    gutterBottom
                                                >
                                                    {selectedTitular?.dadosPessoais?.nome}
                                                </Typography>

                                                {selectedTitular?.dataNomeacao &&
                                                    <Typography
                                                        variant="body2"
                                                        textAlign="center"
                                                        color="text.secondary"
                                                    >
                                                        Data de Nomeação:{' '}
                                                        <Date date={selectedTitular?.dataNomeacao} />
                                                    </Typography>
                                                }

                                            </CardContent>
                                        </Box>
                                        <IconButton
                                            onClick={fecharDetalhes}
                                            sx={{
                                                position: 'absolute',
                                                top: 20,
                                                right: 20,
                                                background: '#fff',

                                                '&:hover': {
                                                    background: '#f5f5f5',
                                                }
                                            }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </Box>

                                    <Box p={5} width={'100%'}>

                                        <Typography
                                            variant="h5"
                                            color="primary"
                                            gutterBottom
                                        >
                                            Biografia
                                        </Typography>

                                        <Typography
                                            variant="body1"
                                            sx={{
                                                mt: 3,
                                                lineHeight: 2,
                                                fontSize: 17,
                                            }}
                                        >
                                            {selectedTitular?.biografia || 'Sem biografia disponível.'}
                                        </Typography>

                                        <ButtonLeft title={'Voltar à Lista'} funcao={fecharDetalhes} />
                                    </Box>
                                </Box>
                            )}
                        </Box>
                    </Fade>

                    {/* LISTA */}
                    {!selectedTitular && (
                        <>
                            <TitularesDiretores
                                funcao="Director Geral"
                                label="DIRECTORES"
                            />

                            <TitularesDiretores
                                funcao="Chefe de Departamento"
                                label="CHEFES DE DEPARTAMENTO"
                            />
                        </>
                    )}

                </>
            )}

        </Container>
    );
}